<template>
  <div class="overflow-y-scroll">
    <vue-editor v-model="content" :editorToolbar="customToolbar"></vue-editor>
  </div>
</template>

<script>
import { VueEditor } from 'vue2-editor';

export default {
  name: 'RichTextEditor',
  components: {
    VueEditor,
  },
  props: {
    info: {
      type: String,
      default: '', // Default value if no prop is passed
    },
  },
  data() {
    return {
      content: this.info, // Initialize content with the info prop
      customToolbar: [
        ['bold', 'italic', 'underline'],
        [{ list: 'ordered' }, { list: 'bullet' }],
        [{ header: [1, 2, 3, false] }],
        [{ align: [] }],
      ],
    };
  },
  watch: {
    content(newValue) {
      this.$emit('content-changed', newValue);
    },
    info(newInfo) {
      this.content = newInfo; // Update content if the info prop changes
    },
  },
};
</script>

<style lang="css">
@import '~vue2-editor/dist/vue2-editor.css';
@import '~quill/dist/quill.core.css';
@import '~quill/dist/quill.bubble.css';
@import '~quill/dist/quill.snow.css';
</style>
